var _excluded = ["sendEvent", "transport", "debug"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { AnalyticsProvider as FeCoAnalyticsProvider } from '@domain-group/fe-co-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AnalyticsProvider = _ref => {
  var sendEvent = _ref.sendEvent,
    transport = _ref.transport,
    debug = _ref.debug,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAllhomesApi = useAllhomesApi(),
    _useAllhomesApi$sendA = _useAllhomesApi.sendAnalytics,
    sendAnalytics = _useAllhomesApi$sendA === void 0 ? null : _useAllhomesApi$sendA,
    _useAllhomesApi$toggl = _useAllhomesApi.toggledFeatures,
    toggledFeatures = _useAllhomesApi$toggl === void 0 ? {} : _useAllhomesApi$toggl;
  return ___EmotionJSX(FeCoAnalyticsProvider, _extends({
    debug: toggledFeatures[ToggledFeatureKey.ANALYTICS_DEBUG] || debug,
    transport: transport || sendEvent || sendAnalytics
  }, props));
};